import { Image, VStack } from "@chakra-ui/react";
import React from "react";
import { ProgressStatusIcons } from "../../../utils/accordion/accordionHelper";
import accordion_images from "../../../utils/accordion/accordion_images";

const ProgressStatus = ({
  status,
  progress,
  subTopicId,
  isNormal,
  isSideNav,
}) => {
  const unlockedIcon = (progressItem, isNormal) => {
    if (
      progressItem?.taskType &&
      progressItem?.taskStatus &&
      isNormal &&
      !isSideNav
    ) {
      return (
        <Image
          w={"28px"}
          h={"28px"}
          src={ProgressStatusIcons(
            progressItem?.taskType,
            progressItem?.taskStatus
          )}
          alt="progress icon"
        />
      );
    } else if (
      progressItem?.taskStatus === "inProgress" &&
      !isNormal &&
      !isSideNav
    ) {
      return (
        <Image
          w={"28px"}
          h={"28px"}
          src={accordion_images.subTopicTasksInProgress}
          alt="Latest Homework in progress"
        />
      );
    } else if (
      progressItem?.taskStatus === "completed" &&
      !isNormal &&
      !isSideNav
    ) {
      return (
        <Image
          w={"28px"}
          h={"28px"}
          src={accordion_images.subTopicTasksCompleted}
          alt="Latest Homework Completed"
        />
      );
    } else {
      return (
        <Image
          w={"28px"}
          h={"28px"}
          src={accordion_images.subTopicTasksUnlocked}
          alt="Subtopic Unlocked "
        />
      );
    }
  };

  const matchingProgress = progress.find(
    (item) => item?.subtopicId === subTopicId
  );
  // console.log("MATCHING PROGRESS", matchingProgress);

  return (
    <VStack paddingLeft={4}>
      {status ? (
        unlockedIcon(matchingProgress, isNormal)
      ) : (
        <Image
          w={"28px"}
          h={"28px"}
          src={accordion_images.subTopicTasksLocked}
          alt="Subtopic Locked"
        />
      )}
    </VStack>
  );
};

export default ProgressStatus;
